export enum WeeklyOrders {
  ONE_TO_TEN = "1-10",
  ELEVEN_TO_TWENTYFIVE = "11-25",
  TWENTY_SIX_TO_FIFTY = "26-50",
  FIFTY_ONE_TO_ONEHUNDRED = "51-100",
  ONEHUNDRED_ONE_TO_FIVEHUNDRED = "101-500",
  OVER_FIVE_HUNDRED = "500+",
  UNKNOWN = "UNKNOWN",
}

export const WeeklyOrdersLabels: Record<WeeklyOrders, string> = {
  [WeeklyOrders.ONE_TO_TEN]: "1-10",
  [WeeklyOrders.ELEVEN_TO_TWENTYFIVE]: "11-25",
  [WeeklyOrders.TWENTY_SIX_TO_FIFTY]: "26-50",
  [WeeklyOrders.FIFTY_ONE_TO_ONEHUNDRED]: "51-100",
  [WeeklyOrders.ONEHUNDRED_ONE_TO_FIVEHUNDRED]: "101-500",
  [WeeklyOrders.OVER_FIVE_HUNDRED]: "500+",
  [WeeklyOrders.UNKNOWN]: "Je ne sais pas",
};

export enum ApplicantRole {
  OWNER = "OWNER",
  OPERATIONS_MANAGER = "OPERATIONS_MANAGER",
  RESTAURANT_MANAGER = "RESTAURANT_MANAGER",
  ASSISTANT_MANAGER = "ASSISTANT_MANAGER",
  CHEF = "CHEF",
}

export const ApplicantRoleLabels: Record<ApplicantRole, string> = {
  [ApplicantRole.OWNER]: "Propriétaire du restaurant",
  [ApplicantRole.OPERATIONS_MANAGER]: "Manager des opérations",
  [ApplicantRole.RESTAURANT_MANAGER]: "Manager restaurant",
  [ApplicantRole.ASSISTANT_MANAGER]: "Assistant manager",
  [ApplicantRole.CHEF]: "Chef cuisinier",
};

export interface RestaurantRequest {
  _id: string;
  displayName: string;
  address: string;
  city: string;
  weeklyOrders: WeeklyOrders;
  role: ApplicantRole;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  createdAt: string;
}
